import { useCallback } from "react"
import { useDispatch } from "react-redux"
import validate from "validate.js";
import { createValidationStructure } from "../../../components/Helper";

export const useValidation = (tabName) => {

    const dispatch = useDispatch()

    const updateError = useCallback((errorKeys)=>(errors) => {
        dispatch({type:"ValidationErrors/updateValidationErrors",payload:{tabName,errors,errorKeys}})
    }, [tabName])

    const validateError = useCallback((params, validationPattern) => {
        let errors = validate(params, validationPattern) || {}
        errors = createValidationStructure(errors)
        updateError(Object.keys(validationPattern))(errors)
    }, [tabName, updateError])

    return { validateError, updateError }
}